import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import './AdminMenuUpload.css';

const AdminMenuUpload = () => {
  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type === 'application/json') {
      setFile(selectedFile);
    } else {
      toast.error('Please select a valid JSON file');
      event.target.value = null;
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.error('Please select a file to upload');
      return;
    }

    setIsUploading(true);
    const formData = new FormData();
    formData.append('menuFile', file);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/menu-items/bulk`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.details || 'Failed to upload menu items');
      }

      const result = await response.json();
      toast.success(`Successfully added ${result.count} menu items`);
      setFile(null);
      // Reset file input
      e.target.reset();
    } catch (error) {
      console.error('Upload error:', error);
      toast.error(error.message || 'Failed to upload menu items');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="admin-upload-container">
      <h2>Upload Menu Items</h2>
      <form onSubmit={handleUpload} className="upload-form">
        <div className="file-input-container">
          <input
            type="file"
            accept=".json"
            onChange={handleFileChange}
            disabled={isUploading}
            id="menu-file-input"
          />
          <label htmlFor="menu-file-input" className="file-input-label">
            {file ? file.name : 'Choose JSON file'}
          </label>
        </div>
        
        <button 
          type="submit" 
          disabled={!file || isUploading}
          className="upload-button"
        >
          {isUploading ? 'Uploading...' : 'Upload Menu Items'}
        </button>
      </form>
      
      <div className="upload-instructions">
        <h3>Instructions</h3>
        <p>Upload a JSON file containing menu items in the following format:</p>
        <pre>
{`{
  "menuItems": [
    {
      "title": "Dish Name",
      "description": "Short description",
      "ingredients": [...],
      "instructions": [...],
      ...
    }
  ]
}`}
        </pre>
      </div>
    </div>
  );
};

export default AdminMenuUpload; 